import type * as React from 'react';

import { BLOCK_LIST_OL } from '@gitbook/doc-core';
import type { BlockProps } from '@gitbook/slate-react';

import { BasicBlockWrapper } from './BasicBlockWrapper';

/**
 * Basic renderer for a list block.
 */
export function BasicBlockList(props: BlockProps): React.ReactElement {
    const { node, children } = props;

    return (
        <BasicBlockWrapper tag={node.type === BLOCK_LIST_OL ? 'ol' : 'ul'} {...props}>
            {children}
        </BasicBlockWrapper>
    );
}
